import React, { useState, useEffect, useCallback } from 'react';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from "@mui/material";

import Backdrop from '@mui/material/Backdrop';
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { url, urlLive } from "../../constant";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import dayjs from 'dayjs';
import 'dayjs/locale/en-gb'; // Import the locale for British English


function Tables() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [salesReports, setSalesReports] = useState([]);
  const [salesReportName, setSalesReportName] = useState("");
  const [salesReportSurName, setSalesReportSurName] = useState("");
  const [email, setEmail] = useState("");
  const [isSalesDirector, setIsSalesDirector] = React.useState(true);
  const [errors, setErrors] = useState({ name: "" });

  // Dialog states for delete and edit confirmation
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteSalesReportId, setDeleteSalesReportId] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editSalesReportId, setEditSalesReportId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  // Add loading states
  const [loading, setLoading] = useState(false);  // For fetching categories
  const [formLoading, setFormLoading] = useState(false);  // For form submission


  // Fetch sales report when the component mounts

  useEffect(() => {

    // const requestOptions = {
    //   method: "GET",
    //   redirect: "follow"
    // };

    // fetch(`${url}auth/request-categories`, requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     if (result.categories) {
    //       setCategories(result.categories);
    //     }
    //   })
    //   .catch((error) => console.error("Error fetching categories:", error));


    getSalesReports();

  }, []);

  const getSalesReports = () => {

    setLoading(true);  // Show loader while fetching data
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`${url}auth/get-sales-reps`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.sales_reports) {
          setSalesReports(result.sales_reports);
        }
      })
      .catch((error) => console.error("Error fetching sales reports:", error))
      .finally(() => {
        setLoading(false);  // Hide loader after fetching
      });

  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const validateForm = () => {
    const newErrors = { name: "", surname: "", email: "" };
    let isValid = true;

    // Validate sales report name
    if (!salesReportName) {
      newErrors.name = "Nome è obbligatorio";
      isValid = false;
    }

    // Validate sales report surname
    if (!salesReportSurName) {
      newErrors.surname = "Cognome è obbligatorio";
      isValid = false;
    }

    // Validate email
    if (!email) {
      newErrors.email = "Email è obbligatorio";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email is not valid";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };


  // const handleSubmit = () => {
  //   if (validateForm()) {
  //     console.log("Category added:", { categoryName });
  //     setCategoryName(""); // Reset form after submission
  //     setSelectedTab(0);    // Switch back to List tab
  //   }
  // };


  const handleSubmit = () => {

    if (validateForm()) {

      setFormLoading(true);  // Show loader during form submission
      // Create a FormData object with the new category name
      const formData = new FormData();
      formData.append("Name", salesReportName);
      formData.append("Surname", salesReportSurName);
      formData.append("Email", email);
      formData.append("IsSalesDirector", isSalesDirector);
      var akLoginUser = JSON.parse(localStorage.getItem('user'));
      formData.append('CreationUser', `${akLoginUser.user.IdUser}`)

      // Configure the POST request
      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow",
      };

      // Send the POST request to create a new sales-reps
      fetch(`${url}auth/create-sales-reps`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success) {
            // Assuming the result includes a success status or newly created category

            getSalesReports();
            // Reset form after submission
            setSalesReportName("");
            setSalesReportSurName("");
            setEmail("");
            setIsSalesDirector(true);
            setSelectedTab(0); // Switch back to the List tab
            console.log("Sales Report added successfully:", result);
          } else {

            if (result.msg !== undefined) {
              alert(result.msg);
            }

          }
        })
        .catch((error) => console.error("Error Sales Report:", error))
        .finally(() => {
          setFormLoading(false);  // Hide loader after form submission
        });

    }

  };


  const formatDate = (dateString) => {
    if (!dateString) {
      return '';
    }
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const columns = [
    { Header: "ID", accessor: "IdSalesRep" },
    { Header: "Nome", accessor: "Name" },
    { Header: "Cognome", accessor: "Surname" },
    { Header: "Email", accessor: "Email" },
    { Header: "Direttore Commerciale", accessor: "IsSalesDirector" },
    { Header: "Creato il", accessor: "CreationUser" },
    { Header: "Data Creazione", accessor: "CreationDate" },
    { Header: "Aggiornato da", accessor: "UpdateUser" },
    { Header: "Aggiornato il", accessor: "UpdateDate" },
    { Header: "Actions", accessor: "actions" }, // Action Column
  ];

  const rows = salesReports.map((salesReport) => ({
    IdSalesRep: salesReport.IdSalesRep,
    Name: salesReport.Name,
    Surname: salesReport.Surname,
    Email: salesReport.Email,
    IsSalesDirector: salesReport.IsSalesDirector ? 'Yes' : 'No',
    CreationUser: salesReport.CreationUserName,
    CreationDate: salesReport.CreationDate ? dayjs(salesReport.CreationDate).format('DD-MM-YYYY') : '',
    UpdateUser: salesReport.UpdateUserName,
    UpdateDate: salesReport.UpdateDate ? dayjs(salesReport.UpdateDate).format('DD-MM-YYYY') : '',
    actions: (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {/* Edit Button */}
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleEditDialogOpen(salesReport)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            color: '#fff',
            // backgroundColor: '#1976d2',
            backgroundColor: '#183759',
            '&:hover': { 
              // backgroundColor: '#1565c0',
              backgroundColor: '#204b80',
             },
          }}
        >
          {/* Edit */}
          Modifica

        </Button>

        {/* Delete Button */}
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => handleDeleteDialogOpen(salesReport.IdSalesRep)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            backgroundColor: '#d32f2f',
            color: '#fff',
            '&:hover': { backgroundColor: '#c62828' },
          }}
        // disabled={category.active}
        >
          {/* Delete */}
          Cancella
        </Button>
      </Box>
    ),
  }));

  const handleEditDialogOpen = (salesReport) => {
    setEditSalesReportId(salesReport.IdSalesRep);
    setSalesReportName(salesReport.Name);
    setSalesReportSurName(salesReport.Surname);
    setEmail(salesReport.Email);
    setIsSalesDirector(salesReport.IsSalesDirector ? true : false);
    setOpenEditDialog(true);
  };

  const handleEditDialogClose = () => {

    setEditSalesReportId(null);
    setSalesReportName("");
    setSalesReportSurName("");
    setEmail("");
    setIsSalesDirector(true);
    setOpenEditDialog(false);
  };

  const handleEditSubmit = () => {
    if (validateForm()) {
      const formData = new FormData();
      formData.append("Name", salesReportName);
      formData.append("Surname", salesReportSurName);
      formData.append("Email", email);
      formData.append("IsSalesDirector", isSalesDirector);

      var akLoginUser = JSON.parse(localStorage.getItem('user'));
      formData.append('UpdateUser', `${akLoginUser.user.IdUser}`)

      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow"
      };

      fetch(`${url}auth/update-sales-reps/${editSalesReportId}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log(result);

          // Update the sales report list after editing
          // getCategories();

          getSalesReports();
          handleEditDialogClose();
        })
        .catch((error) => console.error("Error updating category:", error));
    }
  };

  // Open the confirmation dialog for deletion
  const handleDeleteDialogOpen = (SalesReportId) => {
    setDeleteSalesReportId(SalesReportId);
    setOpenDeleteDialog(true);
  };


  // Close the confirmation dialog without deleting
  const handleDeleteDialogClose = () => {
    setDeleteSalesReportId(null);
    setOpenDeleteDialog(false);
  };

  // Perform the delete action if confirmed
  const handleDeleteConfirm = () => {
    const requestOptions = {
      method: "DELETE",
      redirect: "follow"
    };

    fetch(`${url}auth/delete-sales-reps/${deleteSalesReportId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        // Refresh the sales report list after deletion
        setSalesReports(salesReports.filter(salesReport => salesReport.IdSalesRep !== deleteSalesReportId));
        setOpenDeleteDialog(false);
      })
      .catch((error) => console.error("Error deleting sales report:", error));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Loader Component */}
      <Backdrop open={loading || formLoading} sx={{ color: '#fff', zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                // bgColor="info"  
                bgColor="#183759"
                borderRadius="lg"
                coloredShadow="info"
              >
                {/* <MDTypography variant="h6" color="white">
                 Sales Report
                </MDTypography> */}
                <MDTypography variant="h6" color="white">
                  {/* Sales Rep */}
                  Vendite Rapporto
                </MDTypography>
              </MDBox>

              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="basic tabs example"
                >
                  {/* <Tab label="List Sales Report" />
                  <Tab label="Add Sales Report" /> */}
                  <Tab label="Elenco Vendite Rapporto" />
                  <Tab label="Nuovo Vendite Rapporto" />
                </Tabs>

                {selectedTab === 0 && (
                  <MDBox pt={3}>
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={{ defaultValue: 10 }}
                      showTotalEntries={false}
                      noEndBorder
                      currentPageIndex={currentPageIndex}
                      setCurrentPageIndex={setCurrentPageIndex}
                    />
                  </MDBox>
                )}

                {selectedTab === 1 && (
                  <MDBox pt={3} px={2}>
                    <MDTypography variant="h6" mb={3} align="center">
                      {/* Add Sales Report */}
                      Nuovo Vendite Rapporto

                    </MDTypography>
                    <Grid container spacing={2} justifyContent="center">
                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            // label="Name"
                            label="Nome"
                            variant="outlined"
                            fullWidth
                            value={salesReportName}
                            onChange={(e) => setSalesReportName(e.target.value)}
                            error={!!errors.name}
                            helperText={errors.name}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            // label="Surname"
                            label="Cognome"
                            variant="outlined"
                            fullWidth
                            value={salesReportSurName}
                            onChange={(e) => setSalesReportSurName(e.target.value)}
                            error={!!errors.surname}
                            helperText={errors.surname}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>

                        <MDBox mb={2}>
                          <TextField
                            label="Email"
                            variant="outlined"
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={!!errors.email}
                            helperText={errors.email}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                            type="email"  // Makes sure the input is recognized as an email
                          />
                        </MDBox>

                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5} >

                        <MDBox sx={{ display: 'flex', alignItems: 'center' }}>
                          <Checkbox
                            checked={isSalesDirector}
                            onChange={(e) => setIsSalesDirector(e.target.checked)}
                            sx={{
                              mr: 1,
                              '&.Mui-checked .MuiSvgIcon-root': {
                                backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                                borderColor: '#344767',
                              },
                            }} // Adds spacing between checkbox and text
                          />
                          {/* <MDTypography variant="body2">isSalesDirector</MDTypography> */}
                          <MDTypography variant="body2">Direttore Commerciale</MDTypography>
                        </MDBox>

                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <Button
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{
                              //  py: 1.5,
                              fontSize: '14px',
                              borderRadius: '8px',
                              height: '40px',
                              color: '#ffffff',
                              // '&:hover': {
                              //   backgroundColor: '#0b5ed7',
                              // },
                              backgroundColor: '#183759', // 💙 Base background color
                              '&:hover': {
                                backgroundColor: '#204b80', // ✨ Slightly lighter hover
                              },
                            }}

                          >
                            {/* Add Sales Report */}
                            Salva

                          </Button>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {/* Confirm Deletion */}
          Conferma l'eliminazione
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* Are you sure you want to delete this sales report? This action cannot be undone. */}
            Sei sicuro di voler eliminare questa vendite rapporto? Questa azione non può essere annullata.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            {/* Cancel */}
            Annulla
          </Button>
          <Button onClick={handleDeleteConfirm} color="error">
            {/* Delete
             */}
            Cancella
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Confirmation Dialog */}
      <Dialog
        open={openEditDialog}
        onClose={handleEditDialogClose}
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Edit Sales Report</DialogTitle> */}

        <DialogTitle>Modifica Vendite Rapporto </DialogTitle>

        <DialogContent>

          {/* Sales Report Name */}
          <TextField
            // label="Name"
            label="Nome"
            variant="outlined"
            fullWidth
            value={salesReportName}
            onChange={(e) => setSalesReportName(e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, marginTop: 2 }}
          />

          {/* Sales Report Surname */}
          <TextField
            // label="Surname"
            label="Cognome"
            variant="outlined"
            fullWidth
            value={salesReportSurName}
            onChange={(e) => setSalesReportSurName(e.target.value)}
            error={!!errors.surname}
            helperText={errors.surname}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
          />

          {/* Email */}
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
            type="email"
          />

          {/* Sales Director Checkbox */}
          <MDBox sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
            <Checkbox
              checked={isSalesDirector}
              onChange={(e) => setIsSalesDirector(e.target.checked)}
              sx={{
                mr: 1,
                '&.Mui-checked .MuiSvgIcon-root': {
                  backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                  borderColor: '#344767',
                },
              }} // Adds spacing between checkbox and text
            />
            <MDTypography variant="body2">Direttore Commerciale</MDTypography>
          </MDBox>


        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
          Annulla
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
          Salva
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );

}

export default Tables;
